/**
 * @Description: 用于存储产品模块中硬件产品，耗材的类别信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  MaterialCategoryModel,
  MaterialCategorySearchModel,
  MaterialCategoryPageSearchModel,
  MaterialCategoryAddModel,
  MaterialCategoryUpdateModel,
  IdsModel
} from '@/model/product/MaterialCategoryModel'

const baseUrl = Route.product + '/materialCategory'

/**
 * 搜索分页数据
 */
export const pageSearchMaterialCategory = (param: MaterialCategoryPageSearchModel) => {
  return https().request<RootObject<PageRespModel<MaterialCategoryModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchMaterialCategory = (param: MaterialCategorySearchModel) => {
  return https().request<RootObject<MaterialCategoryModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getMaterialCategory = (id: number) => {
  return https().request<RootObject<MaterialCategoryModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addMaterialCategory = (param: MaterialCategoryAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateMaterialCategory = (param: MaterialCategoryUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeMaterialCategory = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveMaterialCategory = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
